import Alert from '@mui/material/Alert';
import type { ReactNode } from 'react';

export function ErrorState({
  message = 'Something went wrong loading this data.',
}: {
  message?: string;
}): ReactNode {
  return <Alert severity="error">{message}</Alert>;
}
